
import React, { useState } from 'react';
import { Button } from '../base/Button';

export const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div className="flex items-center">
            <a href="/" className="flex items-center space-x-3">
              <img 
                src="https://static.readdy.ai/image/cd36f9883938bafd66620af1a497dfc4/922a6cc1bcbe4a849c9d8b3340221f4a.png" 
                alt="TopInstal Snajdr Logo" 
                className="h-16 w-16 object-contain"
                style={{ mixBlendMode: 'multiply' }}
              />
              <span className="text-2xl font-bold text-gray-900">TopInstal Snajdr</span>
            </a>
          </div>
          
          <div className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-8">
              <a href="/nase-prace" className="text-gray-700 hover:text-blue-600 px-4 py-3 text-lg font-medium">
                Naše práce
              </a>
            </div>
          </div>
          
          <div className="hidden md:block">
            <Button href="tel:+420720520035" variant="primary" size="lg">
              <i className="ri-phone-line mr-2 text-xl"></i>
              720 520 035
            </Button>
          </div>
          
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-700 hover:text-blue-600 p-2"
            >
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
            </button>
          </div>
        </div>
        
        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white border-t">
              <a href="/nase-prace" className="text-gray-700 hover:text-blue-600 block px-4 py-3 text-lg font-medium">
                Naše práce
              </a>
              <div className="px-3 py-2">
                <Button href="tel:+420720520035" variant="primary" className="w-full" size="lg">
                  <i className="ri-phone-line mr-2 text-xl"></i>
                  720 520 035
                </Button>
              </div>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};
